import React, { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

const Information = forwardRef((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 14 14"
  >
    <path
      d="M6.41663 4.08268H7.58329V5.24935H6.41663V4.08268ZM6.41663 6.41602H7.58329V9.91602H6.41663V6.41602ZM6.99996 1.16602C3.77996 1.16602 1.16663 3.77935 1.16663 6.99935C1.16663 10.2193 3.77996 12.8327 6.99996 12.8327C10.22 12.8327 12.8333 10.2193 12.8333 6.99935C12.8333 3.77935 10.22 1.16602 6.99996 1.16602ZM6.99996 11.666C4.42746 11.666 2.33329 9.57185 2.33329 6.99935C2.33329 4.42685 4.42746 2.33268 6.99996 2.33268C9.57246 2.33268 11.6666 4.42685 11.6666 6.99935C11.6666 9.57185 9.57246 11.666 6.99996 11.666Z"
      fill="currentColor"
    />
  </SvgIcon>
));

export default memo(Information);
